<script>
import { getEventIconDefinition } from '@modules/consolidator/utils/Events/Events.js'

export default {
  name: 'EventIcon',
  props: {
    event: {
      type: Object,
      default: () => null,
    },
    iconKey: {
      type: String,
      default: 'operacao',
    },
    backgroundColor: {
      type: String,
      default: '',
    },
    backgroundSize: {
      type: [Number, String],
      default: 24,
    },
    iconName: {
      type: String,
      default: '',
    },
    iconColor: {
      type: String,
      default: '',
    },
    iconSize: {
      type: [Number, String],
      default: 16,
    },
    iconProps: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    iconDefinition() {
      return getEventIconDefinition({
        eventItem: this.event,
        key: this.iconKey,
      })
    },
    avatarColor() {
      return this.backgroundColor || this.iconDefinition.color || ''
    },
    normalizedIconProps() {
      const base = { ...this.iconProps }
      const definition = this.iconDefinition || {}

      const effectiveName = this.iconName || definition.name || base.name

      let effectiveColor
      if (this.iconColor) {
        effectiveColor = this.iconColor
      } else if (definition.iconColor) {
        effectiveColor = definition.iconColor
      } else if (base.color) {
        effectiveColor = base.color
      } else {
        effectiveColor = 'white'
      }

      return {
        ...base,
        color: effectiveColor,
        size: this.iconSize || base.size,
        name: effectiveName,
      }
    },
  },
}
</script>

<template>
  <v-avatar :color="avatarColor" :size="backgroundSize">
    <icon-svg v-bind="normalizedIconProps" />
  </v-avatar>
</template>

<style lang="sass"></style>
